// extracted by mini-css-extract-plugin
export default {"sectionTwo":"SectionTwo_sectionTwo__SMs8z","company":"SectionTwo_company__5dkMt","logoAscensus":"SectionTwo_logoAscensus__sTw-a","mainCall":"SectionTwo_mainCall__+X4oY"};